var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * LocalNetworkPermissionModal
 *
 * Displayed when Chrome 142+ blocks QZ Tray's loopback WebSocket because the
 * "Local Network Access" (or "Apps on device") permission has not been granted.
 *
 * Two modes:
 *   'prompt' – offer a "Request Permission" button that triggers Chrome's
 *              native dialog by attempting a QZ Tray connection.
 *   'denied' – show browser-specific help links so the user can re-enable it.
 */
import React, { useState } from 'react';
import { Modal, Button } from 'antd';
var BROWSER_LINKS = [
    { browser: 'Chrome', url: 'https://support.google.com/chrome/answer/114662' },
    {
        browser: 'Edge',
        url: 'https://support.microsoft.com/en-us/topic/control-a-website-s-access-to-the-local-network-in-microsoft-edge-ef7eff4c-676d-4105-935c-2acbcd841d51'
    },
    {
        browser: 'Firefox',
        url: 'https://support.mozilla.org/en-US/kb/control-personal-device-local-network-permissions-firefox'
    },
    { browser: 'Safari', url: 'https://support.apple.com/en-us/102229' }
];
export var LocalNetworkPermissionModal = function (_a) {
    var visible = _a.visible, status = _a.status, onClose = _a.onClose, onRequestPermission = _a.onRequestPermission;
    var _b = useState(false), requesting = _b[0], setRequesting = _b[1];
    var handleRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRequesting(true);
                    return [4 /*yield*/, onRequestPermission()];
                case 1:
                    _a.sent();
                    setRequesting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    if (!visible || !status)
        return null;
    if (status === 'prompt') {
        return (_jsx(Modal, __assign({ title: 'Printer Access Required', visible: visible, onCancel: onClose, footer: [
                _jsx(Button, __assign({ onClick: onClose }, { children: "Cancel" }), 'cancel'),
                _jsx(Button, __assign({ type: 'primary', loading: requesting, onClick: handleRequest }, { children: "Request Permission" }), 'request')
            ] }, { children: _jsx("p", { children: "To access the printer, we need you to enable \u201CApps on device\u201D or \u201CLocal Network Access\u201D permission." }, void 0) }), void 0));
    }
    if (status === 'denied') {
        return (_jsxs(Modal, __assign({ title: 'Local Network Access Denied', visible: visible, onCancel: onClose, footer: [
                _jsx(Button, __assign({ onClick: onClose }, { children: "Close" }), 'close'),
                _jsx(Button, __assign({ type: 'primary', loading: requesting, onClick: handleRequest }, { children: "Try Again" }), 'retry')
            ] }, { children: [_jsx("p", { children: "The \u201CLocal Network Access\u201D permission is blocked. To re-enable it:" }, void 0), _jsxs("ol", __assign({ style: { marginTop: 8, marginBottom: 12, paddingLeft: 20 } }, { children: [_jsx("li", { children: "Click the lock icon in your browser's address bar" }, void 0), _jsx("li", { children: "Find \u201CLocal Network Access\u201D or \u201CApps on device\u201D" }, void 0), _jsxs("li", { children: ["Change it to ", _jsx("strong", { children: "Allow" }, void 0)] }, void 0), _jsxs("li", { children: ["Click ", _jsx("strong", { children: "Try Again" }, void 0), " below"] }, void 0)] }), void 0), _jsx("p", __assign({ style: { marginBottom: 8 } }, { children: "Or follow the guide for your browser:" }), void 0), _jsx("ul", __assign({ style: { paddingLeft: 20 } }, { children: BROWSER_LINKS.map(function (_a) {
                        var browser = _a.browser, url = _a.url;
                        return (_jsxs("li", __assign({ style: { marginBottom: 6 } }, { children: [_jsx("strong", { children: browser }, void 0), " \u2014", ' ', _jsx("a", __assign({ href: url, target: '_blank', rel: 'noopener noreferrer' }, { children: url }), void 0)] }), browser));
                    }) }), void 0)] }), void 0));
    }
    return null;
};
export default LocalNetworkPermissionModal;
